import { render, staticRenderFns } from "./SellerBase.vue?vue&type=template&id=3894a77e"
import script from "./SellerBase.vue?vue&type=script&lang=js"
export * from "./SellerBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports